module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/costume_01@2x-572d9c39fba7757851dc86e2b4024538.webp";